import { AccountTariff } from 'console/billing/account-tariff/types';
export function accountTariffName(tariff) {
    switch (tariff) {
        case AccountTariff.free:
            return 'Базовый';
        case AccountTariff.zont_pro:
            return 'Профи';
        default:
            return tariff;
    }
}
export function isUpgrade(oldTariff, newTariff, tariffs) {
    if (tariffs) {
        const cost_old = tariffs.find((el) => el.id === oldTariff)?.month_price_x100;
        const cost_new = tariffs.find((el) => el.id === newTariff)?.month_price_x100;
        if (cost_new !== undefined && cost_old !== undefined) {
            if (cost_new > cost_old)
                return true;
        }
        return false;
    }
    return false;
}
export function getTariffProName() {
    return accountTariffName(AccountTariff.zont_pro);
}
